import { AdminHierarchy } from 'admin/config/admin'
import { AdminTypes } from 'types'

/**
 * Check if given admin matches access or has inherited access through admin hierarchy
 */
export default function checkAdminAccess(administratorType: AdminTypes, access: AdminTypes): boolean {
  return administratorType && access && (administratorType === access || AdminHierarchy[administratorType].includes(access))
}